import React from "react";
import { GridActionsCellItem } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import EstadoBadge from "../components/ui/EstadoBadge";
import OrigenBadge from "../components/ui/OrigenBadge";
import TipoBadge from "../components/ui/TipoBadge";
import { Box, Typography } from "@mui/material";
import { DATA_GRID_FONT_SIZE } from "../../../components/ui/dataGridStyles";

/**
 * Definiciones de columnas para DataGrid de incidencias
 * Configuración específica del dominio con renderizadores custom
 */

/**
 * Genera las columnas del DataGrid de incidencias
 * @param {Function} onEdit - Callback al hacer clic en editar
 * @returns {Array} Definiciones de columnas
 */
export const generarColumnasIncidencias = (onEdit) => {
  return [
    {
      field: "idNote",
      headerName: "ID",
      width: 70,
      renderCell: (params) => (
        <Typography sx={{ fontWeight: 600, fontSize: DATA_GRID_FONT_SIZE.CELDA }}>
          #{params.value}
        </Typography>
      ),
    },
    {
      field: "titulo",
      headerName: "Incidencia",
      flex: 2.2,
      minWidth: 200,
      renderCell: (params) => (
        <Typography
          sx={{
            fontSize: DATA_GRID_FONT_SIZE.CELDA,
            color: "#495057",
            whiteSpace: "normal",
            lineHeight: 1.3,
          }}
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: "referencia",
      headerName: "Referencia",
      flex: 0.7,
      minWidth: 120,
      renderCell: (params) => (
        <Typography sx={{ fontSize: DATA_GRID_FONT_SIZE.CELDA, color: "#495057" }}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: "tipoNote",
      headerName: "Tipo",
      width: 100,
      renderCell: (params) => (
        <Box>
          <TipoBadge tipo={params.value} />
        </Box>
      ),
    },
    {
      field: "origenLabel",
      headerName: "Origen",
      width: 130,
      renderCell: (params) => (
        <Box>
          <OrigenBadge origen={params.row.origen} label={params.value} />
        </Box>
      ),
    },
    {
      field: "nombreEmpleado",
      headerName: "Creado por",
      flex: 0.5,
      minWidth: 120,
      renderCell: (params) => (
        <Typography
          sx={{
            fontSize: DATA_GRID_FONT_SIZE.CELDA,
            color: params.value ? "#495057" : "#6c757d",
          }}
        >
          {params.value || "Sin asignar"}
        </Typography>
      ),
    },
    {
      field: "estado",
      headerName: "Estado",
      width: 130,
      renderCell: (params) => (
        <Box>
          <EstadoBadge estado={params.value} label={params.row.estadoTexto} />
        </Box>
      ),
    },
    {
      field: "fechaModificado",
      headerName: "Modificado",
      flex: 1.1,
      minWidth: 150,
      renderCell: (params) => (
        <Typography sx={{ fontSize: DATA_GRID_FONT_SIZE.CELDA, color: "#6c757d" }}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: "fechaCreado",
      headerName: "Creado",
      flex: 1.1,
      minWidth: 150,
      renderCell: (params) => (
        <Typography sx={{ fontSize: DATA_GRID_FONT_SIZE.CELDA, color: "#6c757d" }}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Acciones",
      width: 90,
      sortable: false,
      filterable: false,
      getActions: ({ id }) => [
        <GridActionsCellItem
          key="editar"
          icon={<EditIcon />}
          label="Editar incidencia"
          onClick={() => onEdit(id)}
          sx={{ color: "#495057" }}
        />,
      ],
    },
  ];
};
